import React, { FC } from "react";

import { useBoolean } from "~/hooks";

import { Button } from "~/components/atoms";
import { AreaChartBox, PieChartBox } from "~/components/molecules";
import { ScalableBarGraph } from "~/components/organisms/";

import { EmployeeSurveysSummariesAnswers } from "./EmployeeSurveysSummariesAnswers";

import {
  EmployeeSurveyQuestionSummaryGroupByDateType,
  EmployeeSurveyQuestionSummaryType,
} from "~/domains";

type PropsType = {
  summaries: EmployeeSurveyQuestionSummaryType[];
  summaryGroupDates?: EmployeeSurveyQuestionSummaryGroupByDateType[];
  title: string;
  className?: string;
};

export const EmployeeSurveySubmissionSummary: FC<PropsType> = ({
  summaries,
  summaryGroupDates,
  title,
  className = "",
}) => {
  const { isChecked: open, toggle } = useBoolean(false);
  const optionSummaries = summaries.filter(
    (summary) =>
      "answer" in summary && "point" in summary && "count" in summary,
  );

  return (
    <div className={className}>
      {optionSummaries.length > 0 && (
        <div className="grid grid-cols-1 miniTablet:grid-cols-2 gap-6 mt-4">
          <div className="bg-white rounded-lg border border-secondary-200 shadow-sm overflow-hidden">
            <PieChartBox
              isLoading={false}
              dataSets={optionSummaries.map((summary) => ({
                label: summary.answer,
                value: summary.count,
              }))}
              title={title}
              className="bg-transparent"
              onlyModalTitle
            />
          </div>
          <div className="bg-white rounded-lg border border-secondary-200 shadow-sm overflow-hidden">
            <ScalableBarGraph
              perforManceData={optionSummaries.map((summary) => ({
                name: summary.answer,
                value: summary.count,
              }))}
              isLoading={false}
              title={title}
              className="bg-transparent"
              onlyModalTitle
            />
          </div>
          {summaryGroupDates && (
            <div className="miniTablet:col-span-2 bg-white rounded-lg border border-secondary-200 shadow-sm overflow-hidden">
              <AreaChartBox
                isLoading={false}
                title={title}
                datasets={summaryGroupDates.map((summary) => ({
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                  name: summary.date,
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                  value: summary.point,
                }))}
                className="bg-transparent"
                onlyModalTitle
              />
            </div>
          )}
        </div>
      )}
      {!(optionSummaries.length > 0) && (
        <div>
          <div className="text-center">
            <Button
              onClick={toggle}
              color="primary"
              size="md"
              outline={false}
              text={open ? "回答一覧を隠す" : "回答一覧を見る"}
            />
          </div>
          {open && (
            <div className="mt-6 space-y-4">
              <div className="border-t border-secondary-200 pt-4">
                <h3 className="text-secondary-900 font-semibold mb-4 text-lg">
                  回答詳細
                </h3>
                <div className="space-y-4">
                  {summaries.map((summary, index) => (
                    <EmployeeSurveysSummariesAnswers
                      key={index}
                      summary={summary}
                      className="border border-secondary-200 shadow-sm"
                    />
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
